import { useQuery } from '@hooks/reactQuery';

import { sectors } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getSectorsByFilter } from '@api/sectors';

import { extractQueryParams } from '@utils/common';

import { TCMNodeVendorTechnology } from '@interfaces/cmModule/dto/cmModuleDTO';
import { ISectorSettingDTO } from '@interfaces/map/dto/sectorsDTO';

import { SECTOR_SETS } from '@constants/queryKeys';

interface IUseQuerySectorsByFilterReturn {
	sectorSets: ISectorSettingDTO[];
	isInitialLoading: boolean;
	isLoading: boolean;
	isFetching: boolean;
	count: number;
}

export const useQuerySectorsByFilter = (params: Partial<TCMNodeVendorTechnology>): IUseQuerySectorsByFilterReturn => {
	const { vendor, technology } = params || {};
	const {
		page,
		pageSize,
		sortDirection,
		sortFieldName,
	} = useAppSelector(sectors);

	const {
		data: { items: sectorSets, count } = {},
		isInitialLoading,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [SECTOR_SETS, { page, pageSize, sortDirection, sortFieldName, technology, vendor }],
		queryFn: extractQueryParams(getSectorsByFilter),
		enabled: [vendor],
	});

	return {
		sectorSets: sectorSets || [],
		isInitialLoading,
		isLoading,
		isFetching,
		count: count || 0,
	};
};
